var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMobileMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    viewBox: "0 0 20 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42857 1.57146L4.28571 1.57146L4.28571 4.42861L1.42857 4.42861L1.42857 1.57146ZM-6.24448e-08 4.42861L0 5.85718L1.42857 5.85718L4.28571 5.85718L5.71429 5.85718L5.71429 4.42861L5.71429 1.57146L5.71429 0.142891L4.28571 0.142891L1.42857 0.142891L-2.49779e-07 0.142891L-1.87335e-07 1.57146L-6.24448e-08 4.42861ZM8.57143 1.57146L11.4286 1.57146L11.4286 4.42861L8.57143 4.42861L8.57143 1.57146ZM7.14286 4.42861L7.14286 5.85718L8.57143 5.85718L11.4286 5.85718L12.8571 5.85718L12.8571 4.42861L12.8571 1.57146L12.8571 0.142891L11.4286 0.142891L8.57143 0.142891L7.14286 0.142891L7.14286 1.57146L7.14286 4.42861ZM15.7143 4.42861L15.7143 1.57146L18.5714 1.57146L18.5714 4.42861L15.7143 4.42861ZM14.2857 5.85718L15.7143 5.85718L18.5714 5.85718L20 5.85718L20 4.42861L20 1.57146L20 0.142891L18.5714 0.142891L15.7143 0.142891L14.2857 0.142891L14.2857 1.57146L14.2857 4.42861L14.2857 5.85718Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMobileMore);
export default __webpack_public_path__ + "static/media/nav-mobile-more.4c47642dacec7dff5dc8f84da668e988.svg";
export { ForwardRef as ReactComponent };